export var MembersQueryInitialResponse = {
    query: undefined,
    members: [],
};
//# sourceMappingURL=MembersQueryResponse.js.map